import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CourseListBody from "./CourseListBody";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ProgressBar from "react-bootstrap/ProgressBar";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getCheckListInsert,
  getCourseDetailEcom,
  getCourseDetailEcomClear,
  getCourseRelated,
  getCourseRelatedClear,
  getModuleFavGet,
  getModuleListing,
  getModuleListingBroker,
  getModuleListingClear,
  getModuleListingClearBroker,
  getMyLearningPaths,
  getMyLearningPathsClear,
  getRankStatus,
  getRankStatusClear,
  getRecommendIds,
  getRecommendIdsClear,
  getSingleLP,
  getSingleLPClear,
  markModuleProgress,
  markModuleProgressClear,
  openHamburger,
  saveAnswersReq,
} from "../../redux/courses/actions";
import { applyTheme, checkRankStatusFunc, clickStreamUser, convertHoursToMins, convertTimeFormat, convertToObjects, formatLPCoursesList, getFormatCourseListFromWoo, getFormatedDataOfLPUtils, markModuleProgressUtils, SessionKeys } from "../../utils/AppUtils";
import { ModuleComp } from "./ModuleComp";
import JSZip from "jszip";
import { Spinner } from "react-bootstrap";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import CONFIG from "../../utils/config";
import { ModuleNotes } from "../../pages/modulePages/ModuleNotes";
import { getModulenotesGet } from "../../redux/courses/actions";
import {
  getModuleNotesDelete,
  getModuleNotesDeleteClear,
  getModuleNotesUpdate,
  getModuleNotesUpdateClear,
} from "../../redux/courses/actions";
import ModuleFav from "../../pages/modulePages/ModuleFav";
import { array } from "yup";
import CongratulationsPopUp from "./CongratulationsPopUp";
import CongPopupAnimation from "./CongPopupAnimation";
import { checkContentAccess } from "../../redux/home/actions";
import Loader from "../Loader/Loader";
import CourseCardListBody from "./CourseCardListBody";
import LPMoreLearn from "./LPMoreLearn"
import useLogin from "../../custom-hooks/useLogin";
import API_LIST from "../../utils/apiList";
import LPdetailComp from "../b2cComponents/LPDetailComp";
import AfterCongratulationsModal from "../modal/AfterCongratulationsModal";
import { useTranslation } from "react-i18next";
import CompletedPage from "../../finwell/pages/CompletedPage";
import ContentLoader from "react-content-loader";

const CourseLaunchSection = ({ isMobile }) => {
  const hamburgerMenu = useRef();
  const [showAllMenu, setShowAllMenu] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // const { isLoggedIn } = useLogin();
  const { t } = useTranslation();
  const iframeRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderMsg, setLoaderMsg] = useState("Please wait")
  const [activeTab, setActiveTab] = useState(1);
  const [loader, setLoader] = useState(false);

   const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  const source = paramsReq.source;
  const via_lp = paramsReq.via_lp;
  const lp_id = paramsReq.lp_id;
  const via_cat = paramsReq.via_cat;
  const cat_id = paramsReq.catId;
  const level_id = paramsReq.level_id;
  const is_level = paramsReq.is_level;
  const cid = paramsReq.cid;
  const from = paramsReq.from;
  const lp_source = paramsReq.lp_source;

  const courseTitleP = paramsReq.courseTitle;
  const mId = paramsReq.mId;
  const courseIdP = paramsReq.courseId;





  const [courseTitle, setCourseTitle] = useState(
    courseTitleP
  );
  const [selectedModule, setSelectedModule] = useState(
    {}
  );
  const [moduleId, setModuleId] = useState(mId);
  const moduleListingData = useSelector((state) => state.courses.moduleListing);
  const moduleListingDataBroker = useSelector(
    (state) => state.courses.moduleListingBroker
  );
  const [notesList, setNotesList] = useState([]);
  const [insertNoteRecord, setInsertNoteRecord] = useState(null);
  const [insertFavRecord, setInsertFavRecord] = useState(null);
  const [moduleData, setModuleData] = useState({});
  const [iframeId, setIframeId] = useState(null);
  const [selectedModulePos, setSelectedModulePos] = useState(null);
  const [isLoad, setIsLoad] = useState(true)
  const [isModuleChange, setIsModuleChange] = useState(false)
  const [reload, setReload] = useState(true);
  const [isAnimCompleted, setIsAnimCompleted] = useState(false);
  const [isPaid, setIsPaid] = useState(false)
  const [hasTeaser, setHasTeaser] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || localStorage.getItem(SessionKeys.API_TOKEN))
  const [showLPLearnMore, setShowLPLearnMore] = useState(false)
  const [purchasedInfo, setPurchasedInfo] = useState({})

 
  // const source = params.get("source");
  // const cid = params.get("cid");
  // const via_lp = params.get('via_lp');
  // const lp_id = params.get('lp_id');
  // const via_cat = params.get('via_cat');
  // const cat_id = params.get('cat_id');
  // const level_id = params.get('level_id');
  // const is_level = params.get('is_level');
  // const from = params.get('from')
  // const lp_source = params.get("lp_source");

    const authBroker = useSelector((state) => state.auth.authBroker);
  const moduleNotesUpdate = useSelector(
    (state) => state.courses.moduleNotesUpdate
  );
  const moduleProgress = useSelector((state) => state.courses.moduleProgress);
  const recommendIsRes = useSelector((state) => state.courses.recommendIsRes);
  const lpData = useSelector((state) => state.courses.lpData)
  const courseRelatedData = useSelector((state) => state.courses.courseRelated)
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const checkContent = useSelector((state) => state.home.checkContent);
  const userBranding = useSelector(state => state.user.userBranding);
  const courseDetailEcom = useSelector(state => state.courses.courseDetailEcom);
  const rankStatusRes = useSelector((state) => state.courses.rankStatusRes);
  const userRole = useSelector((state) => state.user.role);

  // const moduleData = moduleListing?.payload

  const { courseId } = useParams();
  const { courseCode } = useParams();
  const [congModal, setCongModal] = useState(true);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const moduleNoteData = useSelector(
    (state) => state.courses.moduleNotesGet.payload
  );
  const nextButton = useRef(null);
  const [isShowCongrat, setIsShowCongrat] = useState(false)
  const [isFree, setIsFree] = useState(true)
  const [isLPCompleted, setIsLPCompleted] = useState(false)
  const [singleLpData, setSingleLpData] = useState({})
  const [courseListingData, setCourseListingData] = useState([])
  const [showNextCourse, setShowNextCourse] = useState(false)
  const [isLastRecord, setIsLastRecord] = useState(true)
  // If free course - 1, paid course - 2, lp/oblp - 3
  const [fromSection, setFromSection] = useState(1)
  const [backgroundURL, setBackgroundURL] = useState('')

  const myLearningPathsData = useSelector(state => state.courses.myLearningPaths)
  const [learningPathData, setLearningPathData] = useState({});
  const [showShimmer, setShowShimmer] = useState(false);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [show, setShow] = useState(false);
  const [newRank, setNewRank] = useState('')
  const [isGuest, setIsGuest] = useState(false);
  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.payload.user.role.includes('guest')) {
        setIsGuest(true);
      }
    }
  }, [authBroker])


  useEffect(()=>{
    return () =>{
      return (() => {
      dispatch(getModuleListingClearBroker())
      dispatch(getModuleListingClear())
      dispatch(getCourseDetailEcomClear())
      setSelectedModule({})
    })
    }
  },[])




  const toggleNavDesktop = () => {
    var bodyclass = document.querySelector("body");
    var btnEl = document.querySelector("#mySidenav");
    var main = document.querySelector(".main");
    var varmain = document.querySelector(".smart-bar");
    var togicon = document.querySelector(".opens-course-launch");
    var toogleicon = document.querySelector("#openbtnd .closetoogle");
    var footerslide = document.querySelector(".footersection");
    var smartBar = document.querySelector(".smart-bar");
    // console.log(btnClasslist)
    if (btnEl.classList.contains("open")) {
      //document.getElementById("openbtnd").innerHTML = "<span class='closetoogle'></span>";
      btnEl.classList.remove("open");
      toogleicon.classList.add("closeopen");
      if (varmain) {
        varmain.style.marginLeft = "26.25rem";
      }
      if (smartBar) {
        // smartBar.style.marginLeft = "26.25rem";
        smartBar.style.cssText = 'margin-left: 26.25rem;padding-left: 2rem';
      }
      main.style.marginLeft = "26.25rem";
      togicon.classList.add("closeopenbt");
      bodyclass.classList.remove("sidemenuopened");
      footerslide.style.marginLeft = "26.25rem";
    } else {
      //document.getElementById("openbtnd").innerHTML ="<span class='opentogglbar'></span>";
      btnEl.classList.add("open");
      toogleicon.classList.remove("closeopen");
      main.style.marginLeft = "0";
      if (varmain) {
        varmain.style.marginLeft = "0";
      }
      togicon.classList.remove("closeopenbt");
      bodyclass.classList.add("sidemenuopened");
      footerslide.style.marginLeft = "0";
      if (smartBar) {
        smartBar.style.cssText = 'margin-left: 0;padding-left: 0';

      }
    }
  };
  useEffect(() => {
    if (!isMobile && isLoggedIn) {
      // alert('logged')
      clickStreamUser("course_launch_page", {
        courseCode: courseCode,
        userId: auth.authBroker?.payload?.user.user_id,
      });
    } else {
      clickStreamUser("course_launch_page", {
        courseCode: courseCode,
        username: localStorage.getItem(SessionKeys.USERNAME),
      });

    }
    window.scrollTo(0, 0);
    //getSingleLPData();
  }, [dispatch]);

  useEffect(() => {
    console.log('Branding Data', userBranding)
    if (isMobile && !_.isEmpty(userBranding)) {
      const branding = userBranding.payload.payload;
      if (!_.isEmpty(branding)) {
        applyTheme(branding)
      }
    }
  }, [isMobile, userBranding])

  useEffect(() => {
    // find the type of module
    // if type === scorm and source != broker, call the notes and fav api
    // else if source === broker and type != scorm, call the marProgress api
    if (moduleId && !_.isEmpty(authBroker)) {
      // console.log("getNotes 2");
      // console.log("TODO AFTER CHANGES");
      if ((source != "broker")) {
        dispatch(
          getModulenotesGet({
            module: "getNotes",
            postData: {
              mid: moduleId,
              uid: authBroker?.payload?.user?.user_id,
              course_code: courseCode.split("?")[0],
            },
          })
        );
        dispatch(
          getModuleFavGet({
            module: "getModuleFavourites",
            // token: localStorage.getItem(SessionKeys.API_TOKEN),
            postData: {
              mid: moduleId,
              uid: authBroker?.payload?.user?.user_id,
              course_code: courseCode.split("?")[0],
            },
          })
        );
      }

      // if (
      //   (!['mov', 'mp4', 'mkv', 'webm', 'm3u8', 'url', 'pdf','video'].includes(selectedModule?.rsp_scromdata[0]?.type?.toLowerCase()))) {
      //   if (isLoggedIn) {
      //     console.log("selected module while calling api", selectedModule)
      //     markModuleProgressFunc(moduleId, selectedModule?.crs, selectedModule?.rsp_scromdata[0]?.type)
      //   }
      // }

    }
  }, [moduleId, authBroker]);

  useEffect(() => {
    if (!_.isEmpty(moduleData) && !_.isEmpty(selectedModule) && !_.isEmpty(moduleId))
      if (moduleData?.asset_id === "4" && moduleData?.crs_progress !== 100) {

        markModuleProgressFunc(moduleId, selectedModule?.crs, selectedModule?.rsp_scromdata[0]?.type)
      }
  }, [moduleData, selectedModule, moduleId])

  const markModuleProgressFunc = (mId, cId, type) => {
    markModuleProgressUtils(dispatch, mId, cId, source, type, from, via_lp, lp_id);
    // let reqBody = {
    //   module_id: mId,
    //   token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //   course_id: cId,
    //   source: source==='broker'?"broker":"xsel",
    //   type: _.toLower(type)
    // }

    // if (from==="lp" || via_lp ==="true") {
    //   reqBody.lp_id = lp_id;
    // }

    // dispatch(
    //   markModuleProgress({
    //     module: "markModuleProgress",
    //     postData: reqBody,
    //   })
    // );
  }

  useEffect(() => {
    if (source === "xsel" || source === "ecom") {
      let user_id = ""
      if (!_.isEmpty(auth.authBroker)) {
        // setIsLoading(true);
        setModuleData({});

        // courseCode.split("?")[0]
        user_id = auth.authBroker?.payload?.user?.user_id;
        // dispatch(checkContentAccess({
        //   module: 'checkContentAccess',
        //   postData: {
        //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //     origin: source === 'ecom' ? 'xsel' : 'broker',
        //     entity_id: source === 'ecom' ? courseCode.split("?")[0] : '',
        //     entity_type: 'courses'
        //   }
        // }))

      }
      // dispatch(
      //   getModuleListing({
      //     module: "getNIITAdminModule",
      //     postData: {
      //       user_id: user_id,
      //       course_id: courseCode.split('?')[0],
      //     },
      //   })
      // );


      let reqBody = {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        lp_id: lp_id,
        session_id: localStorage.getItem(SessionKeys.SESSION_ID),
        entity_id: cid,
        language: activeLanguage ? activeLanguage : ""
      };
      if (from === "lp" || via_lp === "true") {
        reqBody.lp_id = lp_id;
      } else if (from === "bundle") {
        reqBody.bundle_id = lp_id;
      }

      dispatch(
        getCourseDetailEcom({
          URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.COURSE_DETAIL_ECOM}`,
          payload: reqBody,
          method: "post",
          isJSON: true,
          language: activeLanguage ? activeLanguage : ""
        })
      )
    } else {
      // setIsLoading(true);
      setModuleData({});

      let payload = {
        module: "get_all_course_modules",
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        courseId: courseCode.split('?')[0],
        language: activeLanguage ? activeLanguage : ""
      };
      if (from === "lp" || via_lp === "true") {
        payload.lpId = lp_id;
      } else if (from === "bundle") {
        payload.bundle_id = lp_id;
      }
      dispatch(
        getModuleListingBroker(payload)
      );
    }
  }, [authBroker])

  useEffect(() => {
    // console.log('CHECK CONTENT', checkContent)
    if (!_.isEmpty(checkContent)) {
      if (checkContent.status === "success") {
        const data = checkContent.payload.payload;
        if (!_.isEmpty(data)) {
          // setIsFree(data.is_free)
          if (via_lp === 'true' || from === "lp") {
            setFromSection(3)
          } else if (data.is_free) {
            setFromSection(1)
          } else {
            setFromSection(2)
          }
          // dispatch(checkContentAccessClear());
        }
      }
    }
  }, [checkContent]);

  useEffect(() => {
    if (source === "xsel" || source === "ecom") {
      if (
        !_.isEmpty(courseDetailEcom) &&
        courseDetailEcom.status === "success"
      ) {
        console.log('dataModules: ', courseDetailEcom.payload.data);
        if (courseDetailEcom?.payload) {
          const modulesInfo = _.cloneDeep(courseDetailEcom.payload.data);
          if (!_.isEmpty(modulesInfo.purchased_info)) {
            setPurchasedInfo(modulesInfo.purchased_info)
          } else {
            setPurchasedInfo({})
          }
          modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
          if (modulesInfo.modules.length > 0) {
            modulesInfo.modules[0].isLock = false;
            for (let [index, modules] of modulesInfo.modules.entries()) {
              modules.isLock = modules.isLock === false ? modules.isLock : true;
              if (modules.progress > 0) {
                modules.isLock = false;
                if (index + 1 !== modulesInfo.modules.length)
                  modulesInfo.modules[index + 1].isLock =
                    _.toNumber(modules.progress) === 100 ? false : true;
              }
            }
          }
          setHasTeaser(modulesInfo.is_teaser)
          console.log("modulesInfo", modulesInfo);
          setModuleData(modulesInfo);
          modulesInfo.modules.map((item, index) => {
            if (item.module_id === selectedModule?.module_id) {
              setSelectedModulePos(index);
              onClickModule(item, index)
            }
          });
        }
      }
    } else {
      if (
        !_.isEmpty(moduleListingDataBroker) &&
        moduleListingDataBroker.status === "success"
      ) {
        // console.log(moduleListingDataBroker.payload.payload);
        if (moduleListingDataBroker?.payload) {
          const modulesInfo = _.cloneDeep(moduleListingDataBroker.payload);
          modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
          if (modulesInfo.modules.length > 0) {
            modulesInfo.modules[0].isLock = false;
            for (let [index, modules] of modulesInfo.modules.entries()) {
              modules.isLock = modules.isLock === false ? modules.isLock : true;
              if (modules.progress > 0) {
                modules.isLock = false;
                if (index + 1 !== modulesInfo.modules.length)
                  modulesInfo.modules[index + 1].isLock =
                    _.toNumber(modules.progress) === 100 ? false : true;
              }
            }
          }

          setIsPaid(false)
          setHasTeaser(false)
          // console.log("modulesInfo", modulesInfo);
          setModuleData(modulesInfo);
          setCourseTitle(modulesInfo.courseName);
          modulesInfo.modules.map((item, index) => {
            if (item.id === (selectedModule?.module_id || mId)) {
              setSelectedModulePos(index);
              setSelectedModule(item)
            }
          });
          dispatch(getModuleListingClearBroker());
        }

        // console.log("moduleData: ", moduleListingDataBroker);
      }
    }
  }, [courseDetailEcom, moduleListingDataBroker]);

  useEffect(() => {
    if (!_.isEmpty(moduleData) && !_.isEmpty(courseDetailEcom)) {
      if (courseDetailEcom.status === 'success') {
        const payload = courseDetailEcom.payload.data;
        console.log('courseDetailEcom', courseDetailEcom, payload)
        if (!_.isEmpty(payload) && !_.isEmpty(payload.purchased_info)) {
          const purchased_info = payload.purchased_info;
          console.log('courseDetailEcom', purchased_info)
          if (purchasedInfo && !_.isEmpty(purchasedInfo)) {
            setIsFree(!purchased_info.is_purchased)
          } else {
            setIsFree(true)
          }
          if (purchased_info.is_purchased ||
            _.toNumber(purchased_info.selling_price) == 0) {
            setIsPaid(false)
          } else {
            setIsPaid(true)
          }
        }

      }
      dispatch(getCourseDetailEcomClear())
    }
  }, [moduleData, courseDetailEcom])

  useEffect(() => {

    if (!_.isEmpty(moduleData) && !_.isEmpty(moduleProgress)) {
      setIsLoading(false)
      if (
        moduleProgress?.status === "success"
      ) {
        // alert(JSON.stringify(moduleProgress))
        const selectModule = _.cloneDeep(selectedModule);
        // alert(JSON.stringify(selectModule))
        console.log('--------b')
        if (parseInt(selectModule.progress) !== 100) {
          if (['mov', 'mp4', 'mkv', 'webm', 'm3u8', 'url', 'pdf'].includes(selectModule?.rsp_scromdata[0]?.type)) {
            selectModule.progress = 100;
            setSelectedModule(selectModule);
          } else {
            setTimeout(() => {
              selectModule.progress = 100;
              setSelectedModule(selectModule);
            }, 8000)
          }

          if ((moduleData?.modules?.length === selectedModulePos + 1)) {
            if (['mov', 'mp4', 'mkv', 'webm', 'm3u8', 'url', 'pdf'].includes(selectModule?.rsp_scromdata[0]?.type)) {
              // if (_.toNumber(moduleData.learning_points) > 0) {
              setTimeout(() => {
                setIsShowCongrat(true)
              }, 2000)
              // }
            } else {
              // if (_.toNumber(moduleData.learning_points) > 0) {
              setTimeout(() => {
                setIsShowCongrat(true)
              }, 10000)
              // }
            }
          }

        }
        dispatch(markModuleProgressClear());

      }
    }
  }, [moduleProgress]);

  useEffect(() => {

    // console.log("selectedmodule", selectedModule);
    if (!_.isEmpty(moduleData)) {
      const moduleDataClone = _.cloneDeep(moduleData);
      // console.log("moduleDataAtProgress3: ", moduleData);
      for (let [index, module] of moduleDataClone.modules.entries()) {
        if (module.module_id === selectedModule?.module_id) {
          // if (moduleDataClone.modules[index].progress < 100)
          moduleDataClone.modules[index].progress = _.toNumber(
            selectedModule?.progress
          );
        }
        module.isLock = module.isLock === false ? module.isLock : true;
        if (module.progress > 0) {
          module.isLock = false;
          if (index + 1 !== moduleDataClone.modules.length)
            moduleDataClone.modules[index + 1].isLock =
              _.toNumber(module.progress) === 100 ? false : true;
        }
      }
      setModuleData(moduleDataClone);
    }
  }, [selectedModule]);

  useEffect(() => {

    const handleProgress = (evt) => {
      console.log("DataObject: ", evt.data)
      let dataObj =
        typeof evt.data === "object" ? evt.data : JSON.parse(evt.data);
      if (dataObj && dataObj.method === "progress") {
        const selectModule = _.cloneDeep(selectedModule);

        console.log('-----moduleDataAtProgress: ', dataObj, selectModule)
        if (parseInt(selectModule.progress) !== 100 && dataObj.module_id === selectModule.module_id) {
          if (source !== 'broker' || parseInt(dataObj.value) !== 100) {
            selectModule.progress = parseInt(dataObj.value);
          }
          console.log('moduleDataAtProgress1: ', dataObj, selectModule)
          if (source !== 'broker' && parseInt(dataObj.value) === 100 && (moduleData?.modules?.length === (selectedModulePos + 1))) {
            // console.log('moduleDataAtProgress1: ',moduleData)
            // if (_.toNumber(moduleData.learning_points) > 0) {
            setIsShowCongrat(true)
            // }
            setTimeout(() => {
              window.scrollTo(0, document.body.scrollHeight);
            }, 1500)

          }
          // alert(source)
          if (parseInt(dataObj.value) === 100 && source === 'broker') {
            // if (parseInt(dataObj.value) > 0 && source === 'broker') {
            // alert(dataObj.value)
            if (isLoggedIn) {
              // alert('isloggedin')
              markModuleProgressFunc(selectModule.module_id, selectedModule?.crs, selectedModule?.rsp_scromdata[0]?.type);
            }
          }
          console.log('--------h')
          setSelectedModule(selectModule);

        }


      }

      if (dataObj && dataObj.type === "recommendations") {
         let ids = dataObj?.data.pathIds;
        let assetIds = dataObj?.data.assetIds;
        let responses = dataObj?.data?.responses;

        if (responses && !_.isEmpty(responses)) {
          let resArray = convertToObjects(responses);
          let lpId = "";
          if (from === "lp" || via_lp === "true") {
              lpId = lp_id;
            }
          let reqObj = {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              asset_id: cid,
              ap_id: lpId,
              assesment_responses: resArray,
           }

        
            console.log('reqObjSAVERES', reqObj)
          dispatch(saveAnswersReq({
            module: "saveAnswersReq",
            postData: reqObj,
          })
        );
        }

        let reqObj = {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              rec_ids: ids || [],
              asset_id: assetIds || [],
            }

        if(assetIds && !_.isEmpty(assetIds)) {
          reqObj.entity_type = "course";
        }

        dispatch(
          getRecommendIds({
            module: "getRecommendIds",
            postData: reqObj,
          })
        );

        

      }
    };
    // if (source !== "broker") {
    window.addEventListener("message", handleProgress);
    return () => {
      window.removeEventListener("message", handleProgress);
    };
    // }
  }, [selectedModule]);

  useEffect(()=>{
    // console.log('recommendIsRes', recommendIsRes)
    if (!_.isEmpty(recommendIsRes)) {
      if (recommendIsRes.status === 'success') {
        navigate('/explore?pillar_id=all');
        dispatch(getRecommendIdsClear());
      }
    }


  },[recommendIsRes])


  useEffect(() => {
    let activeTabName = null;
    switch (activeTab) {
      case 1:
        activeTabName = "Modules";
        break;
      case 2:
        activeTabName = "Resources/Toolkits";
        break;
      case 3:
        activeTabName = "My Favorites";
        break;
      case 4:
        activeTabName = "Notes";
        break;
    }
    clickStreamUser("course_tab_change", {
      courseCode: courseCode,
      activeTab: activeTabName,
    });
  }, [activeTab]);

  useEffect(() => {
    if (!_.isEmpty(lpData)) {
      if (lpData.status === 'success') {
        let learning = _.cloneDeep(lpData.payload.payload)
        if (!_.isEmpty(learning)) {
          let sendFlag = false;
          let pushCourse = false;
          let anyLockExists = false;
          let courseToPush = []
          learning = formatLPCoursesList(learning)
          if (learning.coursesList) {
            for (let [index, course] of learning.coursesList.entries()) {
              console.log(`I am ${course.name} - ${courseCode} - ${course.crscd}`)
              let currentCourse = course;
              let nextCourse = learning.coursesList[index + 1];
              if (!currentCourse?.is_checklist_approved && currentCourse?.is_checklist_present && !sendFlag) {
                if (currentCourse.crs_progress >= 100 && !currentCourse.isLock
                  && (index !== learning.coursesList.length - 1)) {
                  dispatch(
                    getCheckListInsert({
                      module: 'checklist-insert',
                      postData: {
                        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                        lp_id: learning?.id,
                        entity_id: currentCourse.source === 'broker' ? currentCourse.id : currentCourse?.crscd,
                        entity_type: !currentCourse?.is_level ? currentCourse.entity_type : "level"
                      }
                    }))
                  sendFlag = true;
                }
              }

              // if (is_level === 'true') {
              //   if (_.toNumber(course.id) === _.toNumber(level_id)) {
              //     pushCourse = true;
              //   }
              // } else {
              //   if (course.crscd === courseCode.split("?")[0]) {
              //     pushCourse = true;
              //   }
              // }
              if (anyLockExists) {
                if (is_level === 'true') {
                  if (course.id === level_id) {
                    if (course.crs_progress < 100) {
                      learning.newCourseList.push(course)
                    }
                    pushCourse = true;
                    // learning.newCourseList.push(course)
                    // if (course.crs_progress !== 100) {
                    // }
                  } else if (pushCourse) {
                    learning.newCourseList.push(course)
                  } else {
                    if (course.crs_progress < 100) {
                      // learning.newCourseList.push(course)
                      courseToPush.push(course)
                    }
                  }
                } else {
                  if (course.crscd === courseCode.split("?")[0]) {
                    console.log('this is me ' + course.name)
                    pushCourse = true;
                    // learning.newCourseList.push(course)
                    // if (course.crs_progress !== 100) {
                    // }
                  } else if (pushCourse) {
                    learning.newCourseList.push(course)
                  } else {
                    if (course.crs_progress < 100) {
                      // learning.newCourseList.push(course)
                      courseToPush.push(course)
                    }
                  }
                }
              } else {
                if (course.crs_progress < 100) {
                  // learning.newCourseList.push(course)
                  courseToPush.push(course)
                }
              }
            }
            for (let course of courseToPush) {
              learning.newCourseList.push(course)
            }
            learning.coursesList = learning.newCourseList;
          }
          if (learning.coursesList.length === 0) {
            console.log('is Last Record')
            setIsLastRecord(true)
            setShowNextCourse(false)
          } else {
            console.log('show Next Course')
            // TODO: FOR TESTING
            // setIsLastRecord(false)
            // setShowNextCourse(true)
          }
          console.log('LP DATA', learning, courseCode.split("?")[0])
          setSingleLpData(learning)
        }
      } else {
        setSingleLpData({})
      }
      dispatch(getSingleLPClear())
    }
    // return (() => {
    //   setShowNextCourse(false)
    //   setIsLastRecord(true)
    // })
  }, [lpData])

  useEffect(() => {
    if (!_.isEmpty(courseRelatedData)) {
      if (courseRelatedData.status === 'success') {
        if (!_.isEmpty(courseRelatedData.payload.payload)) {
          let courseListing = _.cloneDeep(courseRelatedData.payload.payload);

          if (_.isArray(courseListing)) {
            let formattedList = [];
            for (let course of courseListing) {
              formattedList.push(getFormatCourseListFromWoo(course, isPremiumUser));
            }
            let newFormattedList = [];
            for (let course of formattedList) {
              let pushNextCourse = true;

              // let coursesData = formatWooCourses(data)
              course.isLock = false;

              if (course.source === 'broker') {
                course.is_paid = true;
                if (course.durationUnit === "Hours") {
                  course.duration = convertHoursToMins(course.duration);
                }
                course.duration = convertTimeFormat(_.toNumber(course.duration));
                course.durationUnit = "";
              }
              if (course.crscd === courseCode.split("?")[0]) {
                pushNextCourse = false;
              }
              if (pushNextCourse) {
                newFormattedList.push(course)
              }
            }
            if (!_.isEmpty(newFormattedList)) {
              // TODO: FOR TESTING
              // debugger
              // setShowNextCourse(true)
              // setIsLastRecord(false)
            }
            console.log('FORMAT LISTING', newFormattedList)
            setCourseListingData(newFormattedList)
          }
        }
      } else {
        setCourseListingData([])
      }
      dispatch(getCourseRelatedClear())
    }
    // return (() => {
    //   setShowNextCourse(false)
    //   setIsLastRecord(true)
    // })
  }, [courseRelatedData])

  useEffect(() => {
    if (!_.isEmpty(rankStatusRes)) {
      if (rankStatusRes?.status === "success") {
        let data = rankStatusRes?.payload?.payload;
        if (data.rank_increase) {
          setNewRank(data.rank)
          localStorage.setItem(SessionKeys.CURRENT_RANK, data.rank)
          setShow(true)
          dispatch(getRankStatusClear({}))
        } else {
          setShow(false)
        }
      }
    }
  }, [rankStatusRes])

  useEffect(() => {
    if (isShowCongrat) {
      setTimeout(() => {
        if (via_lp === 'true' || from === "lp") {
          getSingleLPData()
        } else if (via_cat === 'true') {
          getCoursesListingData()
        }
      }, 2000);
    }
    if (isAnimCompleted) {
      if (userRole !== "manager" && !isGuest) {
        checkRankStatusFunc(dispatch, getRankStatus)
      }
      return (() => {
        setIsAnimCompleted(false);
      })
    }
  }, [isShowCongrat, isAnimCompleted])

  const onClickModule = (m, idx) => {
    // console.log("moduleData", m);


    setModuleId(m.module_id);
    setSelectedModulePos(idx);
    console.log('--------idx')
    setSelectedModule(m);
    if (selectedModule.module_id === m.module_id) {
      // setReload(false)
      // setTimeout(() => {
      //   setIsLoad(false)
      //   setReload(true)
      // }, 3000)
    } else {
      setIsModuleChange(true)


      setCourseTitle(m.title);

      setIsModuleChange(false)
      setReload(true)
      setIsLoad(true)
    }
    if (!isMobile) {
      clickStreamUser("course_module_click", {
        courseCode: courseCode,
        moduleId: m.module_id,
        moduleName: m.title,
        userId: auth.authBroker?.payload?.user.user_id,
      });
    } else {
      clickStreamUser("course_module_click", {
        courseCode: courseCode,
        moduleId: m.module_id,
        moduleName: m.title,
        username: localStorage.getItem(SessionKeys.USER_NAME),
      });
    }
  };
  const gotoHome = () => {
    navigate(-1)
    return;
  };

  const generateZIP = () => {
    // window.captureMyEvents(
    //   "jbcToolKitCourseLevel",
    //   {
    //     ttl: moduleList.title,
    //   }
    // )
    const links = [];
    setLoader(true);
    moduleData?.modules?.forEach((module) => {
      module.rsp_toolkit.forEach((m) => {
        links.push(m.url);
      });
    });
    var zip = new JSZip();
    var count = 0;
    var zipFilename = `${moduleData.courseName}.zip`;
    // var zipFilename = "a.zip"

    links.forEach(function (url, i) {
      var filename = links[i];
      filename = filename
        .replace(/[\/\*\|\:\<\>\?\"\\]/gi, "")
        .replace(CONFIG.API_URL, "");
      // loading a file and add it in a zip file
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          setLoader(false);
          throw err; // or handle the error
        }
        zip.file(filename, data, { binary: true });
        count++;
        if (count === links.length) {
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, zipFilename);
            setLoader(false);
          });
        }
      });
    });
  };

  const nextModule = () => {
    for (let [index, module] of moduleData.modules.entries()) {
      if (module.module_id === selectedModule?.module_id) {
        onClickModule(moduleData.modules[index + 1], index + 1);
      }
    }
    window.scrollTo(0, 0);
  };

  const openHamburgerMenu = (data) => {
    dispatch(openHamburger(true));
    if (data.sectionId) {
      const positionTop = document.getElementById("courseTitle").offsetTop;
      // console.log(positionTop);
      // window.scrollY(positionTop);
    }
  };

  const fetchDataFromIframe = (data) => {
    // console.log(data);
    setActiveTab(4);
    setInsertNoteRecord(data);
    openHamburgerMenu(data);
  };

  const openFavourites = (data) => {
    // console.log(data);
    setActiveTab(3);
    setInsertFavRecord(data);
    openHamburgerMenu(data);
  };

  const handlePostMessage = (sid, methodName = "bookmark") => {
    // console.log("sid, methodName", sid, methodName);
    if (iframeRef && iframeRef.current) {
      // console.log("iframe ref present");
      let payload = { method: methodName, section: sid };
      // console.log("payload", payload);
      iframeRef.current.contentWindow.postMessage(JSON.stringify(payload), "*");
    }
  };
  useEffect(() => {
    // dispatch(getModuleNotesUpdate())
  }, [moduleNotesUpdate]);

  useEffect(() => {
    // console.log("update", moduleNotesUpdate);
    if (!_.isEmpty(moduleNotesUpdate)) {
      // console.log("updated", moduleNotesUpdate.payload.status);
      if (moduleNotesUpdate.payload.status === true) {
        // console.log("getNotes 3");
        // TODO: TO CHANGE AFTER MAKING USER ID CHANGES
        // dispatch(getModulenotesGet({
        //   module: 'getNotes',
        //   // token: localStorage.getItem(SessionKeys.API_TOKEN),
        //   postData: { mid: moduleId, uid:user_id, course_code:courseCode }
        // }))
        dispatch(getModuleNotesUpdateClear());
      }
    }
  }, [moduleNotesUpdate]);

  // useEffect(() => {
  //     console.log('update', moduleNotesUpdate)
  //     if (!_.isEmpty(moduleNotesUpdate)) {
  // console.log('updated', moduleNotesUpdate.payload.status)
  // if (moduleNotesUpdate.payload.status === true) {
  //     console.log('getNotes 3')
  // TODO: AFTER CHANGE TO USER ID
  //     dispatch(getModulenotesGet({
  //         module: 'getNotes',
  //         postData: { mid: moduleId, uid:user_id, course_code:courseCode }
  //     }))
  //     dispatch(getModuleNotesUpdateClear())
  // }
  //     }
  // }, [moduleNotesUpdate])

  const sortResources = (arr) => {
    // console.log("ModuleDataa sort resources",arr)
    var array1 = [];
    var array2 = [];
    var glossary = null;
    var coursehelp = null;
    arr?.map((item) => {
      if (item?.title.toLowerCase() === "glossary") {
        glossary = item;
      } else if (item?.title.toLowerCase() === "course help") {
        coursehelp = item;
      } else array1.push(item);
      // if (item.title.toLowerCase() === 'pdf') {
      //     array2 = item.sort(function (a, b) {
      //         return a.localeCompare(b)
      //     })
      //     return array2
      // } else array2.push(item)
    });
    if (glossary != null) {
      array1.push(glossary);
    }
    if (coursehelp != null) {
      array1.push(coursehelp);
    }
    return array1;
  };

  const sortByAlphabetical = (list) => {
    return list
    // if (list.title)


    // return list.sort((a, b) => a.title.localeCompare(b.title));
  };

  // console.log("Index===>", selectedModulePos + 1)
  // console.log("module length", moduleData?.modules?.length)
  // console.log("module progress", parseInt(selectedModule?.progress))
  const [scroll, setScroll] = useState(false)
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10)
    })
  }, [])

  const getSingleLPData = () => {

    setShowShimmer(true)
    if (lp_source === "xsel" || source === "ecom") {
      dispatch(getMyLearningPaths({
        module: 'getMyLearningPathsEcom',
        postData: {
          token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          is_onboarding: 0,
          id: lp_id,
        }
      }))
    } else {
      dispatch(getMyLearningPaths({
        module: 'getMyLearningPaths',
        postData: {
          token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          assigned: 0,
          lp_id: lp_id,
          language: activeLanguage ? activeLanguage : ""
        }
      }))
    }

    // dispatch(getSingleLP({
    //   module: 'singleLPInfo',
    //   postData: {
    //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //     lp_id: lp_id
    //   }
    // }))
  }

  useEffect(() => {
    // console.log('LearningPath', myLearningPathsData)
    if (!_.isEmpty(myLearningPathsData)) {
      if (myLearningPathsData.status === 'success') {
        setIsLoading(false);
        setShowShimmer(false)
        if (!_.isEmpty(myLearningPathsData.payload.payload)) {
          let learning = _.cloneDeep(myLearningPathsData.payload.payload)
          let learningData = getFormatedDataOfLPUtils(learning, dispatch, moduleData.courseName)

          let contentArr = [];
          let learningTemp = _.cloneDeep(learningData);
          for (const record of learningData?.coursesList) {
            if (record.crs_progress < 100 && record.name !== moduleData.courseName) {
              contentArr.push(record)
            }
          }


          for (const record of contentArr) {
            let checklistArray = [];
            record.clInfo = {};
            if (
              record.is_checklist_present &&
              !_.isEmpty(record.checklist_data) &&
              !_.isEmpty(record.checklist_data.checklist_title)
            ) {
              // alert(JSON.stringify(record.checklist_data.checklist_title))
              checklistArray = record.checklist_data.checklist_title;
              let clData = record.checklist_data;
              record.clInfo = {
                lp_name: clData.prgm_nm,
                course_or_level: clData.type,
                course_name: clData.crs,
                course_completion_date: clData.course_completion_date
                  ? clData.course_completion_date
                  : "",
                rea_name: clData.user_name,
                title_array: checklistArray,
              };
              // if (learning.id == 16548) alert(JSON.stringify(record))
            }
          }




          learningTemp.coursesList = contentArr;


          if (learningTemp.coursesList.length === 0) {
            console.log('is Last Record')
            setIsLastRecord(true)
            setShowNextCourse(false)
            setShowLPLearnMore(false)
            setIsLPCompleted(true)
          } else {
            console.log('show Next Course')
            // TODO: TESTING
            // debugger
            setIsLastRecord(false)
            setShowNextCourse(true)
            setShowLPLearnMore(true)
            setIsLPCompleted(false)
          }
          setLearningPathData(learningTemp)
        }
      }
      dispatch(getMyLearningPathsClear())
    }
  }, [myLearningPathsData])

  const getCoursesListingData = () => {
    dispatch(getCourseRelated({
      module: 'courseRelated',
      postData: {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        brokerage_id: localStorage.getItem(SessionKeys.COMPANY_ID),
        category_id: cat_id
      }
    }))
  }

  return (
    <>
      <Loader start={isLoading} msg={loaderMsg} />
      <div className={scroll ? "scrollnavmob" : ""} >
        <div className="d-flex gap-2 align-items-start mb-3 flex-wrap flex-md-nowrap">
          <div className="backgbtn" onClick={() => {
            if (location.state?.from) {
              // Always go back to the correct origin
              navigate(location.state.from, { replace: true });
            } else {
              // fallback if no origin available
              navigate("/", { replace: true });
            }
          }}>
            <button className="bckbtn" >
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="26" rx="8" fill="#D2D7E2" />
                <path d="M6.92 12.5037L12.424 6.98374C12.52 6.88774 12.568 6.77041 12.568 6.63174C12.568 6.49308 12.52 6.37574 12.424 6.27974C12.328 6.18374 12.2107 6.13574 12.072 6.13574C11.9333 6.13574 11.816 6.18374 11.72 6.27974L5 12.9997L11.72 19.7197C11.816 19.8157 11.9333 19.8637 12.072 19.8637C12.2107 19.8637 12.328 19.8157 12.424 19.7197C12.52 19.6237 12.568 19.5064 12.568 19.3677C12.568 19.2291 12.52 19.1117 12.424 19.0157L6.92 13.4957H20.504C20.6427 13.4957 20.76 13.4477 20.856 13.3517C20.952 13.2557 21 13.1384 21 12.9997C21 12.8611 20.952 12.7437 20.856 12.6477C20.76 12.5517 20.6427 12.5037 20.504 12.5037H6.92Z" fill="#415385" />
              </svg>
              <span className="ms-2">Back</span>
            </button>
          </div>
          <h3 id="courseTitle" className="mb-0 yitle" dangerouslySetInnerHTML={{
            __html: moduleData?.courseName || courseTitle || ""
          }}>
          </h3>
        </div>
        {!_.isEmpty(moduleData?.resources_tab) && moduleData?.asset_id === "5" && moduleData?.resources_tab[0]?.url && <a className="cursor-pointer" onClick={() => { window.open(moduleData?.resources_tab[0]?.url, "_blank") }} >
          <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M6.354 5.5H9a.5.5 0 0 0 0-1H5.5a.5.5 0 0 0-.5.5V9a.5.5 0 0 0 1 0V6.354l4.243 4.243a.5.5 0 0 0 .707-.707L6.354 5.5z" />
            <path d="M13 1a2 2 0 0 0-2 2v2.586a1 1 0 0 0 .293.707l3.414 3.414a1 1 0 0 0 1.414 0L15 10.414a1 1 0 0 0 0-1.414L11.586 5H13a1 1 0 0 0 1-1V3a2 2 0 0 0-2-2z" />
          </svg>
          External Resource
        </a>}
        {<p dangerouslySetInnerHTML={{
          __html: moduleData?.coursedescription
        }}></p>}
        {
          ((!showNextCourse || isLastRecord || true) ? _.isEmpty(selectedModule)?<div className="pt-5 loader-launch">
                    {[...Array(4)].map((el, index) => <ContentLoader key={index} backgroundColor={'#dadada'}
    foregroundColor={'#c4c4c4'} className="pt-2 w-100" />)}
                </div> :
            <div id="idModuleComp" className="container-pwc mt-4" aria-hidden="false">
              <div>
                {isShowCongrat && false ? <CompletedPage /> : <ModuleComp
                  purchasedInfo={purchasedInfo || {}}
                  refer={iframeRef}
                  mId={moduleId}
                  assetId={moduleData?.asset_id}
                  courseId={courseIdP}
                  fetchDataFromIframe={fetchDataFromIframe}
                  openFavourites={openFavourites}
                  isMobile={isMobile}
                  source={source}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  moduleInfo={selectedModule}
                  setIsLoad={setIsLoad}
                  isLoad={isLoad}
                  isModuleChange={isModuleChange}
                  reload={reload}
                  setIsLoading={setIsLoading}
                  moduleData={moduleData}
                />}
              </div>

              {moduleData?.asset_id !== "4" && (['pdf', 'external_link',"xlsx"].includes(selectedModule?.rsp_scromdata[0]?.type)
                || ['external_link'].includes(selectedModule?.file_type))
                ? <div className="text-end mb-3"><button
                  className="btn btn-primary btn-block next-course-btn"
                  //style={{ 'margin-right': '20px' }}
                  disabled={
                    parseInt(selectedModule?.progress) === 100 ? true : false
                  }
                  onClick={() => {
                    if (isLoggedIn) {
                      setIsLoading(true)
                      markModuleProgressFunc(moduleId, selectedModule?.crs, selectedModule?.rsp_scromdata[0]?.type);
                    }
                  }}
                >
                  Mark as complete {/*<i className="fa fa-angle-right"></i>*/}
                </button></div> : ""}
              {moduleData &&
                moduleData?.modules &&
                moduleData?.modules[moduleData?.modules.length - 1].module_id !==
                moduleId &&
                selectedModulePos + 1 < moduleData.modules.length ? (
                <div className="containerd">
                  <div className="mb-2rem" aria-hidden="false">
                    <hr className="sepbtnse" />
                    <div className=" d-flex justify-content-end cong">

                      <div className="text-center border-info">
                        {parseInt(selectedModule?.progress) != 100 ? (
                          t("You must complete all activities in this module before continuing.")
                        ) :
                          ((!_.isEmpty(selectedModule?.rsp_scromdata)) && ((selectedModule?.rsp_scromdata[0]?.type?.toLowerCase() === "mov") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "mp4") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "pdf") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "docx") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "xlsx") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "pptx"))
                          ) ? "" : (
                            <div className="next-learn-items">
                              {" "}
                              <span>
                                {t("Congratulations on completing")}{" "}
                                <b>
                                  {moduleData.modules[selectedModulePos]?.title + "!"}
                                </b>
                              </span>
                            </div>
                          )}
                        {parseInt(selectedModule?.progress) != 100 ? (
                          ""
                        ) : (
                          <div className="next-learn-item">
                            <span>
                              {t("Select Continue to proceed to")}{" "}
                              <b>
                                {moduleData.modules[selectedModulePos + 1]?.title}.
                              </b>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    {
                      (isPaid && hasTeaser) ?
                        ""
                        // <div className="d-flex justify-content-end mt-4 next-btn-center" id="nextButon">
                        //   <button
                        //     className="btn btn-primary btn-block next-course-btn"
                        //     disabled={
                        //       parseInt(selectedModule?.progress) < 100 ? true : false
                        //     }
                        //     onClick={() => {
                        //       nextModule();
                        //     }}
                        //   >
                        //     Continue <i className="fa fa-angle-right"></i>
                        //   </button>
                        // </div>
                        :
                        <div className="d-flex justify-content-end mt-4 next-btn-center" id="nextButon">
                          <button
                            className="btn btn-primary btn-block next-course-btn"
                            disabled={
                              parseInt(selectedModule?.progress) < 100 ? true : false
                            }
                            onClick={() => {
                              nextModule();
                            }}
                          >
                            {t("continue")} <i className="fa fa-angle-right"></i>
                          </button>
                        </div>}
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* <CongPopupAnimation/> */}
            </div>
            : !showLPLearnMore
              ?
              <div className="containers sec-II mt-4">
                <div class="rowsed">
                  <LPdetailComp contentList={learningPathData?.coursesList}
                    lpDetail={learningPathData}
                    showShimmer={showShimmer}
                    is_learn_more={true}
                    fromPage={"lp"}
                    isMobile={isMobile}
                  />
                </div>
              </div>
              :
              via_cat === 'true'
                ?
                <div className="containersd mt-4">
                  <div className="related-video-section">
                    <div className="relate-title-sec">
                      <h4 className="titlebox">
                        {t("There's more to Learn")}
                      </h4>
                      <div className="smalltext-videolist">
                        {t("Here are some Related Courses")}
                      </div>
                      <div className="row mt-4">
                        <CourseCardListBody
                          key={1}
                          pageType={'course'}
                          coursesList={courseListingData}  //course.courseList
                          setFavoriteCourse={() => { }}
                          closeModal={() => { }}
                          setCloseModal={() => { }}
                          hasDescription={false}
                          filterData={''}
                          isMobile={isMobile}
                        />
                      </div>
                    </div>
                  </div>

                </div>
                : ""
          )}
        {!isMobile}
        {(isShowCongrat && isLPCompleted) ?  //isShowCongrat
          <>
            <CongPopupAnimation title={(via_lp === "true" || from === "lp") && isLPCompleted ? moduleData.lp_name : moduleData?.courseName}
              lpPoints={moduleData?.learning_points}
              fromPage={isLPCompleted ? 2 : isFree ? 0 : 1}
              name={"course"}
              setIsAnimCompleted={setIsAnimCompleted} />
          </>
          : ""}
      </div>
      {show && <AfterCongratulationsModal show={show}
        setShow={setShow}
        rank={newRank} isMobile={isMobile} />}
    </>
  );
};
export default CourseLaunchSection;


